// src/components/pages/sections/charts/OverviewInstancePercentAreaChart.js
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// Helper to aggregate % views per day by instance
function getPercentData(data) {
    // Collect all unique instances
    const instances = Array.from(new Set(data.map(d => d.instance_name))).sort();
    // Collect all unique days
    const days = Array.from(new Set(data.filter(d => d.view_date).map(d => d.view_date.slice(0, 10)))).sort();

    // Build a matrix: { [day]: { [instance]: count } }
    const dayInstanceCounts = {};
    days.forEach(day => {
        dayInstanceCounts[day] = {};
        instances.forEach(inst => {
            dayInstanceCounts[day][inst] = 0;
        });
    });
    data.forEach(d => {
        if (!d.view_date) return;
        const day = d.view_date.slice(0, 10);
        if (dayInstanceCounts[day] && d.instance_name) {
            dayInstanceCounts[day][d.instance_name]++;
        }
    });

    // For each instance, build a data array of % for each day
    const series = instances.map(inst => ({
        name: inst,
        data: days.map(day => {
            const total = Object.values(dayInstanceCounts[day]).reduce((a, b) => a + b, 0);
            return total === 0 ? 0 : (dayInstanceCounts[day][inst] / total) * 100;
        }),
        stack: 'instances'
    }));

    return { days, series };
}

const OverviewInstancePercentAreaChart = ({ data }) => {
    const { days, series } = getPercentData(data);

    const options = {
        chart: { type: 'area', height: 300 },
        title: { text: 'Percent of Views Per Day by Instance' },
        xAxis: {
            categories: days,
            title: { text: 'Date' },
            labels: { rotation: -45 }
        },
        yAxis: {
            title: { text: 'Percent of Views' },
            max: 100,
            min: 0,
            labels: { format: '{value}%' }
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.y:.1f}%</b><br/>',
            shared: true
        },
        plotOptions: {
            area: {
                stacking: 'percent',
                marker: { enabled: false }
            }
        },
        series: series
    };

    return (
        // <div className="dashboard-overview-element chart-container">
        // add overflow-x-auto
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 overflow-x-auto">  
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    );
};

export default OverviewInstancePercentAreaChart;